// src/pages/AboutPage.js
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

function AboutPage() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-header">
        <button className="page-title-btn" onClick={() => navigate('/')}>
          <img src="/logo.png?v=2" alt="" className="header-logo" />
          PlantID Game
        </button>
      </div>
      <div className="legal-content">
        <h1>Contact</h1>
        <section className="legal-section">
          <p style={{ fontSize: '1.2rem' }}>Email: <a href="mailto:plantidentificationgame@gmail.com">plantidentificationgame@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;
